/**
 * The page around the agent keys, `/agent` (components/agent/AgentPage.tsx):
 * its bar, its head and the line it shows while the account is read. The keys
 * section itself is `agents` in the typed catalogue (strings/agents.ts),
 * translated before this page existed.
 *
 * English in every locale, as strings/learner-desk.ts is: the page is new
 * since paid tasks retired on 2026-10-31, and new copy is English only until
 * the product settles.
 */
import type { Locale } from '../locale';

const en = {
  docTitle: 'Your agent · EngineerOS',
  navigation: 'EngineerOS',
  navCourse: 'The course',
  navBlobor: 'Blobor',
  kicker: 'Your own AI agent',
  title: 'Your agent',
  lede: 'Connect the AI agent you already use. It works on the course as you, in a tab you connect, and Claude Code can report what each run costs so the level can show it.',
  loading: 'Reading your account…',
};

export const agentPageCopy: Record<Locale, typeof en> = {
  en,
  // English only for now (owner, 2026-10-29).
  ar: en,
  // English only for now (owner, 2026-10-29).
  de: en,
  // English only for now (owner, 2026-10-29).
  ja: en,
};
